import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const ProductCard = ({ product, index = 0 }) => {
  const price = product.sale_price || product.price;
  const hasDiscount = product.sale_price && product.sale_price < product.price;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
      className="product-card group"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.slug}`}>
        {/* Image */}
        <div className="relative aspect-square rounded-2xl overflow-hidden bg-sand mb-4 img-zoom">
          <img
            src={product.images?.[0] || 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800'}
            alt={product.name}
            className="w-full h-full object-cover"
          />
          {product.is_custom_available && (
            <span className="absolute top-3 left-3 badge-handcraft bg-sage text-white">
              Custom Available
            </span>
          )}
          {hasDiscount && (
            <span className="absolute top-3 right-3 badge-handcraft bg-terracotta text-white">
              Sale
            </span>
          )}
          {product.stock <= 0 && (
            <div className="absolute inset-0 bg-charcoal/60 flex items-center justify-center">
              <span className="text-white font-medium uppercase tracking-wider text-sm">Out of Stock</span>
            </div>
          )}
        </div>

        {/* Content */}
        <div className="space-y-2">
          <h3 className="font-serif text-xl text-charcoal group-hover:text-accent transition-colors">
            {product.name}
          </h3>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {product.description}
          </p>
          <div className="flex items-center gap-2 pt-1">
            <span className={`font-semibold ${hasDiscount ? 'text-terracotta' : 'text-charcoal'}`}>
              ₹{price.toLocaleString()}
            </span>
            {hasDiscount && (
              <span className="text-sm text-muted-foreground line-through">
                ₹{product.price.toLocaleString()}
              </span>
            )}
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
